module.exports = __webpack_public_path__ + "static/logos-teams-mobile-968b9a05007041dbfc043203d1851cfa.png";